
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LegalNotice from "../pages/legal/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mentions-legales",
    element: <LegalNotice />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
